<template>
  <div id="app">
    <div class="header">
      <img class="close-img" :src="closeImage" alt="" @click="goBack" />
      {{ $t("Login.ToLogin") }}
      <img class="share-img" :src="shareImage" alt="" />
      <!-- <img class="fanyi-img" :src="fanyiImage" alt="" @click="handleLanguage" /> -->
      <div class="fanyi-img" @click="handleLanguage">
        {{ langText }}
      </div>
    </div>
    <div class="title">{{ $t("Login.ToLogin") }}</div>
    <div class="tab">
      <div class="phone" @click="handleTab('phone')" v-if="lang == 'cn'">
        <div>{{ $t("Login.PhoneLogin") }}</div>
        <div class="line" v-if="isPhone"></div>
      </div>
      <div class="email" @click="handleTab('email')">
        <div>{{ $t("Login.EmailLogin") }}</div>
        <div class="line" v-if="!isPhone"></div>
      </div>
    </div>
    <div class="phone-item">
      <img class="phone-img" :src="phoneImage" v-if="isPhone&&lang == 'cn'" alt=""  />
      <img class="phone-img" :src="emailImage" v-if="!isPhone" alt="" />
      <el-input
        class="phone-input"
        :placeholder="isPhone ? $t('Login.PhonePlaceholder') : 'Enter email'"
        v-model="loginForm.phoneNumber"
        @focus="focusPhone"
      >
      </el-input>
    </div>
    <div class="phone-item">
      <img class="phone-img" :src="codeImage" alt="" />
      <el-input
        class="phone-input"
        :placeholder="$t('Login.Code')"
        v-model="loginForm.verificationCode"
        @focus="focusEmail"
      >
      </el-input>
      <div v-if="showCode">
        <span class="code-text" v-if="!isEmail"> {{ $t("Login.Code") }} </span>
        <span class="code-text2" v-else @click="handleCode">
          {{ $t("Login.Code") }}
        </span>
      </div>
      <div v-else>
        <span class="code-text2"> {{ time }}S </span>
      </div>
    </div>
    <div class="agreement">
      <div><el-checkbox v-model="checked"></el-checkbox></div>
      <div class="agreement-text" @click="handleCheck">
        {{ $t("Login.BeforeText") }}
        <a class="agreement-item" @click="toUserAgreement">《{{ $t("Login.UserAgreement") }}》</a>
        {{ $t("Login.and")
        }}<a class="agreement-item" @click="toPrivacy">《{{ $t("Login.privacy") }}》</a>
      </div>
    </div>
    <div class="login">
      <el-button type="primary" @click="handleLogin">{{
        $t("Login.ToLogin")
      }}</el-button>
    </div>

    <div class="pop" v-if="closeTip">
      <div class="tip1">
        <div class="pop-title">{{ $t("Login.readTitle") }}</div>
        <div class="pop-content">
          {{ $t("Login.readBefore") }}
          <a class="color1" @click="toUserAgreement">《{{ $t("Login.UserAgreement") }}》</a
          >{{ $t("Login.and") }}
          <a class="color1" @click="toPrivacy">《{{ $t("Login.privacy") }}》</a>
        </div>
        <div class="tip_button">
          <div class="tip_left" @click="handleNo">{{ $t("Login.cancel") }}</div>
          <div class="tip_right" @click="handleYes">
            {{ $t("Login.agree") }}
          </div>
        </div>
      </div>
    </div>

    <div class="message" v-if="show">
      <div class="tip">{{ message }}</div>
    </div>
    <div class="drawer">
      <el-drawer
        :title="$t('RedemptionCodePage.LanguagesSetting')"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose"
        size="65%"
        :wrapperClosable="false"
      >
        <div class="drawer-item">
          <div
            class="drawer-content"
            v-for="item in langs"
            :key="item.id"
            @click="setLang(item)"
          >
            <div v-if="item.check">
              <img class="checked-img" :src="checkedImage" alt="" />
            </div>
            <div v-else class="checked-img"></div>
            <div>
              <span class="item-left">{{ item.name }}</span>
              <span class="item-right">{{ item.describe }}</span>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
    <div class="mask" v-if="closeTip">
    </div>
  </div>
</template>
  
  <script>
// import { getMd5 } from '@/utils/md5'
import { getVerification, getEmailVerification } from "@/api/login/user";
export default {
  name: "LoginPage",
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      url1:"https://www.xuanjiai.cn/app/privacy.html",
      loginForm: {
        phoneNumber: "",
        verificationCode: "",
      },
      langText: "ZH",
      message: "",
      showCode: true,
      time: 60,
      show: false,
      closeTip: false,
      checked: false,
      isEmail: false,
      phone: "",
      code: "",
      drawer: false,
      direction: "btt",
      isPhone: true,
      queryParams: "",
      detailData: {},
      env: process.env.VUE_APP_BASE_API,
      closeImage: require("@/assets/close.png"),
      fanyiImage: require("@/assets/fanyi.png"),
      shareImage: require("@/assets/share.png"),
      phoneImage: require("@/assets/phone.png"),
      codeImage: require("@/assets/code.png"),
      emailImage: require("@/assets/email.png"),
      checkedImage: require("@/assets/checked.png"),
      lang: "cn",
      langs1: [
        {
          name: "简体中文",
          describe: "简体中文",
          id: 1,
          check: true,
          value: "cn",
        },
        {
          name: "繁體中文",
          describe: "繁体中文",
          id: 2,
          check: false,
          value: "tw",
        },
        {
          name: "English",
          describe: "英文",
          id: 3,
          check: false,
          value: "en",
        },
        {
          name: "日本語",
          describe: "日语",
          id: 4,
          value: "ja",
          check: false,
        },
        {
          name: "한국어",
          describe: "韩语",
          id: 5,
          value: "ko",
          check: false,
        },
        {
          name: "Русский",
          describe: "俄语",
          id: 6,
          value: "ru",
          check: false,
        },
        {
          name: "español",
          describe: "西班牙语",
          id: 7,
          value: "es",
          check: false,
        },
        {
          name: "Français",
          describe: "法语",
          id: 8,
          value: "fr",
          check: false,
        },
        {
          name: "Deutsch",
          describe: "德语",
          id: 9,
          value: "de",
          check: false,
        },
        {
          name: "Português",
          describe: "葡萄牙语",
          id: 10,
          value: "pt",
          check: false,
        },
        {
          name: "Italiano",
          describe: "意大利语",
          id: 11,
          value: "it",
          check: false,
        },
        {
          name: "Türkçe",
          describe: "土耳其语",
          id: 12,
          value: "tr",
          check: false,
        },
        {
          name: "Tiếng Việt",
          describe: "越南语",
          id: 13,
          value: "vi",
          check: false,
        },
        {
          name: "Bahasa Indonesia",
          describe: "印尼语",
          id: 14,
          value: "id",
          check: false,
        },
        {
          name: "हिन्दी",
          describe: "印地语",
          id: 15,
          value: "hi",
          check: false,
        },
        {
          name: "بالعربية",
          describe: "阿拉伯语",
          id: 16,
          value: "ar",
          check: false,
        },
        {
          name: "ภาษาไทย",
          describe: "泰语",
          id: 17,
          value: "th",
          check: false,
        },
      ],
      langs:[],
    };
  },
  watch: {
    lang(val) {
      this.lang = val;
      this.getText(this.lang);
      this.langs.forEach((item) => {
        if (item.value == val) {
          item.check = true;
        } else {
          item.check = false;
        }
      });
    },
  },
  async mounted() {
    this.getLangs()
    if(localStorage.getItem("lang") ==='cn'){
      this.setLanguage()
    }
    this.lang = localStorage.getItem("lang") || 'cn';
    
    this.getText(this.lang);
    // this.loginForm.password = getMd5(this.loginForm.password)
    if(this.lang !=='cn'){
      this.isPhone = false
    }
  },
  methods: {
    getLangs(){
      this.langs=[
        {
          name: "简体中文",
          describe: this.$t('RedemptionCodePage.languages1'),
          id: 1,
          check: true,
          value: "cn",
        },
        {
          name: "繁體中文",
          describe: this.$t('RedemptionCodePage.languages2'),
          id: 2,
          check: false,
          value: "tw",
        },
        {
          name: "English",
          describe: this.$t('RedemptionCodePage.languages3'),
          id: 3,
          check: false,
          value: "en",
        },
        {
          name: "日本語",
          describe: this.$t('RedemptionCodePage.languages4'),
          id: 4,
          value: "ja",
          check: false,
        },
        {
          name: "한국어",
          describe: this.$t('RedemptionCodePage.languages5'),
          id: 5,
          value: "ko",
          check: false,
        },
        {
          name: "Русский",
          describe: this.$t('RedemptionCodePage.languages6'),
          id: 6,
          value: "ru",
          check: false,
        },
        {
          name: "español",
          describe: this.$t('RedemptionCodePage.languages7'),
          id: 7,
          value: "es",
          check: false,
        },
        {
          name: "Français",
          describe: this.$t('RedemptionCodePage.languages8'),
          id: 8,
          value: "fr",
          check: false,
        },
        {
          name: "Deutsch",
          describe: this.$t('RedemptionCodePage.languages9'),
          id: 9,
          value: "de",
          check: false,
        },
        {
          name: "Português",
          describe: this.$t('RedemptionCodePage.languages10'),
          id: 10,
          value: "pt",
          check: false,
        },
        {
          name: "Italiano",
          describe: this.$t('RedemptionCodePage.languages11'),
          id: 11,
          value: "it",
          check: false,
        },
        {
          name: "Türkçe",
          describe: this.$t('RedemptionCodePage.languages12'),
          id: 12,
          value: "tr",
          check: false,
        },
        {
          name: "Tiếng Việt",
          describe: this.$t('RedemptionCodePage.languages13'),
          id: 13,
          value: "vi",
          check: false,
        },
        {
          name: "Bahasa Indonesia",
          describe: this.$t('RedemptionCodePage.languages14'),
          id: 14,
          value: "id",
          check: false,
        },
        {
          name: "हिन्दी",
          describe: this.$t('RedemptionCodePage.languages15'),
          id: 15,
          value: "hi",
          check: false,
        },
        {
          name: "بالعربية",
          describe: this.$t('RedemptionCodePage.languages16'),
          id: 16,
          value: "ar",
          check: false,
        },
        {
          name: "ภาษาไทย",
          describe: this.$t('RedemptionCodePage.languages17'),
          id: 17,
          value: "th",
          check: false,
        },
        {
          name: "فارسی",
          describe: this.$t('RedemptionCodePage.languages18'),
          id: 18,
          value: "fa",
          check: false,
        },
      ]
    },
    setLanguage() {
      let language = this.getPreferredLanguage();
      if (language.startsWith("zh")) {
        localStorage.setItem("lang", "cn");
        this.$i18n.locale = "cn";
        return
      }
      if(language.startsWith("en")){
        localStorage.setItem("lang", "en");
        this.$i18n.locale = "en";
        return
      }
      if (language.startsWith("ja")) {
        localStorage.setItem("lang", "ja");
        this.$i18n.locale = "ja";
        return
      }
      if (language.startsWith("ko")) {
        localStorage.setItem("lang", "ko");
        this.$i18n.locale = "ko";
        return
      }
      if (language.startsWith("ru")) {
        localStorage.setItem("lang", "ru");
        this.$i18n.locale = "ru";
        return
      }
      if (language.startsWith("es")) {
        localStorage.setItem("lang", "es");
        this.$i18n.locale = "es";
        return
      }
      if (language.startsWith("fr")) {
        localStorage.setItem("lang", "fr");
        this.$i18n.locale = "fr";
        return
      }
      if (language.startsWith("de")) {
        localStorage.setItem("lang", "de");
        this.$i18n.locale = "de";
        return
      }
      if (language.startsWith("pt")) {
        localStorage.setItem("lang", "pt");
        this.$i18n.locale = "pt";
        return
      }
      if (language.startsWith("it")) {
        localStorage.setItem("lang", "it");
        this.$i18n.locale = "it";
        return
      }
      if (language.startsWith("tr")) {
        localStorage.setItem("lang", "tr");
        this.$i18n.locale = "tr";
        return
      }
      if (language.startsWith("vi")) {
        localStorage.setItem("lang", "vi");
        this.$i18n.locale = "vi";
        return
      }
      if (language.startsWith("id")) {
        localStorage.setItem("lang", "id");
        this.$i18n.locale = "id";
        return
      }
      if (language.startsWith("hi")) {
        localStorage.setItem("lang", "hi");
        this.$i18n.locale = "hi";
        return
      }
      if (language.startsWith("ar")) {
        localStorage.setItem("lang", "ar");
        this.$i18n.locale = "ar";
        return
      }
      if (language.startsWith("th")) {
        localStorage.setItem("lang", "th");
        this.$i18n.locale = "th";
        return
      }
      
    },
    getPreferredLanguage(){
      return navigator.language || navigator.userLanguage;
    },
    toUserAgreement(){
      this.$router.push({
        path:'/UserAgreement'
      })
    },
    toPrivacy(){
      this.$router.push({
        path:'/PrivacyPage'
      })
    },
    getText(val) {
      const list = {
        cn: "CN",
        tw: "TW",
        en: "EN",
        ja: "JP",
        ko: "KR",
        ru: "RU",
        es: "ES",
        fr: "FR",
        de: "DE",
        pt: "PT",
        it: "IT",
        tr: "TR",
        vi: "VN",
        id: "ID",
        hi: "IN",
        ar: "AE",
        th: "TH",
        fa: "FA",
      };
      this.langText = list[val];
    },
    validateInternational(number) {
      const regex = /^\+?[0-9]{1,4}\s?\d{7,14}$/; // +CCC格式或本地号码
      return regex.test(number);
    },
    handleLogin() {
      if (!this.checked) {
        this.closeTip = true;
      } else {
        this.closeTip = false;
        if (this.isPhone) {
          if (!this.loginForm.phoneNumber) {
            this.$message.error(this.$t("Login.error2"));
            return;
          }
          const pass=  this.validateInternational(this.loginForm.phoneNumber)
          if(!pass){
            this.$message.error(this.$t("Login.error2"));
            return
          }
          if (!this.loginForm.verificationCode) {
            this.$message.error(this.$t("Login.error3"));
            return;
          }
          this.$store
            .dispatch("user/login", this.loginForm)
            .then(() => {
              this.$message.success(this.$t("Login.success"));
              this.$router.push({
                path: "/RedemptionPage",
                // path: "/stripePage",
              });
            })
            .catch(() => {
              console.log("login-error");
            });
        } else {
          if (!this.loginForm.phoneNumber) {
            this.$message.error(this.$t("Login.error1"));
            
            return;
          }
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          const isValid = emailRegex.test(this.loginForm.phoneNumber);
          if (!isValid) {
            this.$message.error(this.$t("Login.error1"));
            return;
          } 
          if (!this.loginForm.verificationCode) {
            this.$message.error(this.$t("Login.error3"));
            return;
          }
          const data = {
            email: this.loginForm.phoneNumber,
            verificationCode: this.loginForm.verificationCode,
          };
          this.$store
            .dispatch("user/login2", data)
            .then(() => {
              this.$message.success(this.$t("Login.success"));
              this.$router.push({
                path: "/RedemptionPage",
              });
            })
            .catch(() => {
              console.log("login-error");
            });
        }
      }
    },
    handleTab(val) {
      this.loginForm.phoneNumber = "";
      this.loginForm.verificationCode = "";
      if (val === "phone") {
        this.isPhone = true;
      } else {
        this.isPhone = false;
      }
    },
    handleLanguage() {
      this.drawer = true;
    },
    handleClose(done) {
      done();
    },
    setLang(val) {
      this.langs.forEach((item) => {
        if (item.name == val.name) {
          item.check = true;
          localStorage.setItem("lang", val.value);
          this.lang = localStorage.getItem("lang");
          this.$i18n.locale = val.value;
          if(this.lang !=='cn'){
            this.isPhone = false
          }
        } else {
          item.check = false;
        }
      });
      this.getLangs()
      this.drawer = false
    },
    focusEmail() {
      this.isEmail = true;
    },
    focusPhone() {
      this.isEmail = false;
    },
    goBack() {
      this.$router.push({
        path: "/RedemptionPage",
      });
    },
    handleYes() {
      this.closeTip = false;
      this.checked = true;
    },
    handleNo() {
      this.closeTip = false;
    },
    handleCheck() {
      this.checked = !this.checked;
    },
    delay(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    },

    async startCountdown(seconds) {
      for (let i = seconds; i > 0; i--) {
        this.time = i;
        await this.delay(1000);
      }
      this.showCode = true;
    },
    handleCode() {
      if (!this.loginForm.phoneNumber) {
        // this.message = this.isPhone ? "请先输入手机号" : "请输入邮箱";
        this.message = this.isPhone ? this.$message.error(this.$t("Login.error2")) : this.$message.error(this.$t("Login.error1"));
        this.show = true;

        setTimeout(() => {
          this.show = false;
        }, 1500);
        return;
      }

      const data = {
        type: "sms",
        phoneNumber: this.loginForm.phoneNumber,
      };
      const data1 = {
        type: "sms",
        email: this.loginForm.phoneNumber,
      };
      
      if (this.isPhone) {
        
      const pass=  this.validateInternational(this.loginForm.phoneNumber)
        if(!pass){
          // this.$message.error('请输入正确的手机号')
          this.$message.error(this.$t("Login.error2"));
          return
        }
        getVerification(data).then((res) => {
          if (res.data.status) {
            this.showCode = false;
            this.startCountdown(60);
          }
        });
      } else {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        const isValid = emailRegex.test(this.loginForm.phoneNumber);

        if (!isValid) {
          this.$message.error(this.$t("Login.error1"));
          return;
        } 
        getEmailVerification(data1).then((res) => {
          if (res.data.status) {
            this.showCode = false;
            this.startCountdown(60);
          }
        });
      }
    },
  },
};
</script>
  
  <style scoped>
#app {
  height: 100vh;
  text-align: left;
  padding:0px 16px
}
.header {
  height: 44px;
  line-height: 44px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: normal;
  color: #3d3d3d;
  text-align: center;
}
.close-img {
  width: 24px;
  height: 24px;
  float: left;
  padding-top: 10px;
  cursor: pointer;
}
.fanyi-img {
  width: 18px;
  height: 18px;
  line-height: 16px;
  float: right;
  /* padding-top: 10px; */
  margin: 10px 16px 0px 0px;
  cursor: pointer;
  border: 2px solid #201f34;
  font-size: 12px;
}
.share-img {
  width: 24px;
  height: 24px;
  float: right;
  padding-top: 10px;
  cursor: pointer;
}
.title {
  font-family: PingFang SC;
  font-size: 36px;
  font-weight: 600;
  line-height: 54px;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
  margin: 26px 26px 26px 10px;
}
.tab {
  display: flex;
}
.phone {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  color: #3d3d3d;
  padding: 0px 24px 0px 8px;
}
.email {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 2-辅字 */
  color: #8e8e8e;
}
.line {
  width: 57px;
  height: 2px;
  /* 2-辅色 */
  background: #201f34;
  margin: 8px auto;
}
.phone-item {
  position: relative;
  margin: 33px 8px 24px 8px;
}
.phone-img {
  position: absolute;
  top: 14px;
  left: 16px;
  z-index: 999;
  width: 24px;
  height: 24px;
}
.phone-input >>> .el-input__inner {
  border-radius: 8px;
  background: #ffffff;
  height: 54px;
  padding-left: 50px;
  font-size: 16px;
}
.code-text {
  position: absolute;
  right: 16px;
  top: 16px;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  /* 沉底色 */
  color: #bfbfc1;
}
.code-text2 {
  position: absolute;
  right: 16px;
  top: 16px;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  color: #201f34;
}
.agreement {
  display: flex;
  margin-bottom: 33px;
}
.agreement-text {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 12px;
  font-variation-settings: "opsz" auto;
  color: #8d8d8d;
}
.agreement-item {
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-variation-settings: "opsz" auto;
  font-family: PingFang SC;
  color: #201f34;
  cursor: pointer;
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
  top: 2px;
  margin-right: 5px;
}
.login {
  width: 100%;
}
::v-deep .el-button {
  width: 100%;
  height: 44px;
  border-radius: 8px;
}

.pop {
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 99999;
}
.tip1 {
  /* 自动布局子元素 */
  width: calc(100% - 64px);
  /* height: 96px; */
  /* 自动布局 */
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 999;
  border-radius: 16px;
  /* 卡片色 */
  background: #ffffff;
  /* margin: 0 auto; */

  font-family: AlibabaPuHuiTi;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0em;

  font-feature-settings: "kern" on;
  /* 文本色 */
  color: #0e273b;
}
.tip_button {
  display: flex;
  width: 100%;
  text-align: center;
}
.tip_left {
  flex: 1;
  border-radius: 0px 0px 0px 16px;
  /* 卡片色 */
  background: #ffffff;
  box-sizing: border-box;
  /* 背景色 */
  border-width: 1px 1px 0px 0px;
  border-style: solid;
  border-color: #f5f5f5;
  padding: 12px 0px;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  /* 文本色 */
  color: #0e273b;
}
.tip_right {
  flex: 1;
  border-radius: 0px 0px 16px 0px;
  /* 卡片色 */
  background: #ffffff;
  box-sizing: border-box;
  /* 背景色 */
  border-width: 1px 0px 0px 0px;
  border-style: solid;
  border-color: #f5f5f5;
  padding: 12px 0px;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  /* 品牌色 */
  color: #f65e3d;
}
.mask {
  position: fixed;
  left: 0px;
  top: 0px;
  height: 100vh;
  width: 100%;
  background: rgba(0, 0, 0, 0.2) !important;
  z-index: 9999;
}
.pop-title {
  padding: 24px 24px 0px 24px;
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  color: #201f34;
}
.pop-content {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
  letter-spacing: normal;
  color: #8e8e8e;
  padding: 0px 24px 24px 24px;
}
.color1 {
  color: #201f34;
  cursor: pointer;
}

.message {
  width: 100%;
  position: fixed;
  top: 40%;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  line-height: 60px;
}
.tip {
  width: 98px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  border-radius: 24px;
  opacity: 1;
  font-family: AlibabaPuHuiTi;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  letter-spacing: 0em;
  font-feature-settings: "kern" on;
  color: #ffffff;
  padding: 0px 20px;
}

.drawer >>> .el-drawer.btt {
  border-radius: 16px 16px 0px 0px;
  background: #f6f8fa;
}
.drawer >>> .el-drawer__header {
  font-family: Source Han Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  letter-spacing: normal;
  /* 2-辅色 */
  color: #201f34;
}
.drawer-item {
  padding: 0px 16px;
  border-radius: 16px;
  /* 卡片色 */
  background: #ffffff;
}
.drawer-content {
  display: flex;
  height: 20px;
  line-height: 20px;
  padding: 14px 16px;
}
.checked-img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.item-left {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  font-variation-settings: "opsz" auto;
  color: #201f34;
  padding: 0px 5px;
}
.item-right {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: normal;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  font-variation-settings: "opsz" auto;
  color: #8e8e8e;
}
.drawer >>> .el-drawer__body {
  padding: 0px 16px;
  margin-top: -10px;
}
</style>
  